import '@divkitframework/divkit/dist/client.css';
import './styles.css';
import { render } from 'solid-js/web';
import App from './App';
import { scheduleSplashFallback } from '@/modules/dom/splash';
import { installStaleChunkReload } from '@/modules/dom/staleChunkReload';
import { appConfig } from '@/config/env';
import { seedPreviewOnboarding } from '@/modules/funnel/previewOnboarding';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Application root was not found');
}

installStaleChunkReload();
seedPreviewOnboarding(appConfig.query.previewOnboardingId, appConfig.search.get('popupVariant'));
scheduleSplashFallback();
render(() => <App />, root);
